<template>
  <v-dialog
    :value="open"
    persistent
    :max-width="400"
    @keydown.esc="$emit('update:open', false)"
    @click:outside="$emit('update:open', false)"
  >
    <v-card
      :min-height="555"
    >
      <div class="px-16 pt-16">
        <span class="icon-hero">
          <v-icon
            class="ma-auto"
            color="primary"
            size="36"
          >
            $faUserLight
          </v-icon>
        </span>
        <v-card-title class="text-h5 modal-title">
          User Created
        </v-card-title>
        <v-card-text
          id="modal-body-text"
          class="text-center"
        >
          An invitation was sent to {{ userFullName }}'s email.
        </v-card-text>
        <v-btn
          color="primary"
          block
          @click="editPermissions"
        >
          Edit Permissions
        </v-btn>
        <div class="mt-2">
          Select which properties this user can access
        </div>
        <div
          style="text-align:center; color:black; font-size:14px; letter-spacing: 0.83px"
          class="my-3"
        >
          OR
        </div>
        <v-btn
          color="primary"
          block
          @click="addAnotherUser"
        >
          Add Another User
        </v-btn>
      </div>
      <v-divider class="mb-6 mt-8" />
      <div class="px-16 pb-8">
        <v-btn
          block
          color="secondary"
          @click="returnToOrg"
        >
          Return to Organization
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'InviteUserModal',
    model: {
      prop: 'open',
      event: 'update:open',
    },
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      userFullName: String,
    },
    methods: {
      editPermissions () {
        this.$emit('edit-user-permissions')
      },
      addAnotherUser () {
        this.$emit('add-another-user')
      },
      returnToOrg () {
        this.$emit('return-to-org')
      },
    },
  }
</script>

<style lang="scss" scoped>
 .icon-hero {
    display: flex;
    background-color: $secondary;
    border-radius: 100px;
    text-align: center;
    width: 83px;
    height: 83px;
    padding: 15px;
    margin: 9px auto 2px auto;
  }
  .btn-container {
    display: flex;
  }
  .align-actions {
    display: inline-block;
    margin: 3px auto 0 auto;
    padding: 15px 8px 8px 8px;
    text-align: center;
    & > button + button {
        margin: 17px 0 0 0;
      }
  }
  .modal-title {
    line-height: 31px;
    color: #{$base};
    white-space: nowrap;
  }
  #modal-body-text {
    line-height: 20px;
    padding: 17px 0 20px 0;
    color: #2B394e;
  }
</style>
